// CircleAnalysisModal.jsx
import React from 'react';

const CircleAnalysisModal = ({ analysis, onClose }) => {
  if (!analysis || !analysis.message) return null;

  const { total_circles, circles_at_limit, message, details } = analysis;
  const percentage = ((circles_at_limit / total_circles) * 100).toFixed(1);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-xl">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-300 bg-white">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-xs font-semibold text-gray-900 uppercase tracking-wide">
                Circle Density Analysis
              </h3>
              <div className="text-xs text-gray-600 mt-1">
                {circles_at_limit} of {total_circles} circles ({percentage}%) at 20-place limit
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl font-light"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 overflow-y-auto max-h-[calc(85vh-140px)]">
          {/* Recommendation Box */}
          <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 text-orange-500 mt-0.5">
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-orange-800 uppercase tracking-wide">
                  Recommendation
                </h4>
                <p className="text-xs text-orange-700 mt-1.5 leading-relaxed">
                  {message}
                </p>
              </div>
            </div>
          </div>

          {/* Detailed Analysis */}
          {details && details.length > 0 && (
            <div>
              <h4 className="text-xs font-semibold text-gray-700 mb-2.5 uppercase tracking-wide">
                Circle Details
              </h4>
              <div className="space-y-2.5">
                {details.map((detail, index) => (
                  <div 
                    key={index}
                    className={`p-3 rounded border ${
                      detail.likely_has_more 
                        ? 'bg-orange-50 border-orange-200' 
                        : 'bg-green-50 border-green-200'
                    }`}
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <div className="font-medium text-gray-900 text-xs">
                          Circle {detail.area_index} 
                          {detail.likely_has_more && (
                            <span className="ml-2 text-orange-600">⚠ Likely more</span>
                          )}
                        </div>
                        <div className="text-gray-600 text-xs mt-1">
                          Radius: {detail.radius}m • Found: {detail.places_found} places
                        </div>
                        <div className="text-gray-500 text-[11px] mt-0.5">
                          {detail.latitude.toFixed(6)}, {detail.longitude.toFixed(6)}
                        </div>
                      </div>
                      <div className={`text-sm font-semibold ${
                        detail.likely_has_more ? 'text-orange-600' : 'text-green-600'
                      }`}>
                        {detail.places_found}/20
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-300 bg-gray-50">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-500 text-white rounded text-xs font-medium hover:bg-blue-600 transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircleAnalysisModal;